<template>
  <v-row justify="center" align="center">
    <v-col cols="12" class="py-0">
      <v-alert class="text-left" border="left" text type="info">
        The offer codes below will only work if the the order discounts option
        is enabled, and the discount code is in date and active.
        <br />
        Currently the order discounts option is
        <b>
          {{
            $store.getters.retrieveOrderDiscountsEnabled
              ? "Enabled"
              : "Disabled"
          }}
        </b>
      </v-alert>

      <v-alert
        class="text-left"
        border="left"
        text
        :type="$store.getters.retrieveDiscountProduct ? 'success' : 'error'"
      >
        <div v-if="$store.getters.retrieveDiscountProduct != false">
          Discount product is configured, the product details are as follows:
          <br />
          Product Number:
          <strong>{{ $store.getters.retrieveDiscountProduct.number }}</strong>
          <br />
          Product Name:
          <strong>{{
            $store.getters.retrieveDiscountProduct.description
          }}</strong>
          <br />
          This product will be added to the order with the a negative value at
          checkout if a valid discount code is applied.
        </div>
        <div v-else>
          Discount product is not found, to be able to use discounts a discount
          product must be assigned
        </div>
      </v-alert>
    </v-col>

    <v-col cols="12">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :search="search"
        :loading="$store.getters.orderdiscountsLoading"
        :headers="headers"
        :items="$store.getters.retrieveDiscounts"
        hide-default-footer
        disable-pagination
        class="elevation-0"
        @click:row="clickedRow"
        loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.discount_amount`]="{ item, value }">
          <span>£{{ value ? parseFloat(value).toFixed(2) : 0 }}</span>
        </template>

        <template v-slot:[`item.discount_percentage`]="{ item, value }">
          <span>{{ value ? parseFloat(value) : 0 }}%</span>
        </template>

        <template v-slot:[`item.discount_active`]="{ item, value }">
          <v-icon right :color="parseInt(value) ? 'success' : 'error'">
            {{ parseInt(value) ? "check_circle_outline" : "cancel" }}
          </v-icon>
        </template>

        <template v-slot:[`item.start_date`]="{ item, value }">
          {{ momentFormatDate(value) }}
        </template>

        <template v-slot:[`item.end_date`]="{ item, value }">
          {{ momentFormatDate(value) }}
        </template>
      </v-data-table>
    </v-col>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <h4>Edit Discount</h4>
          <v-spacer></v-spacer>
          <v-btn icon color text @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-form ref="viewDiscountsForm" @submit.prevent v-model="valid">
          <v-card-text>
            <v-text-field
              label="Code"
              v-model="amend_code"
              type="text"
              :rules="[required('Discount Code')]"
              hint="Code the user must enter to apply the discount"
            />

            <v-radio-group v-model="amend_type" row>
              <v-radio
                color="blue darken-2"
                label="Amount"
                :value="0"
              ></v-radio>
              <v-radio
                color="blue darken-2"
                label="Percentage"
                :value="1"
              ></v-radio>
            </v-radio-group>

            <v-text-field
              v-if="amend_type == 0"
              class="mt-2"
              @focus="$event.target.select()"
              label="Discount Amount"
              prefix="£"
              v-model="amend_discount_amount"
              min="0"
              step=".01"
              type="number"
              :rules="rules_amount"
              hint="Amount in £ to remove from the order total"
            />

            <v-text-field
              v-if="amend_type == 1"
              class="mt-2"
              @focus="$event.target.select()"
              label="Discount Percentage"
              suffix="%"
              v-model="amend_discount_percentage"
              min="0"
              type="number"
              :rules="rules_percentage"
              hint="% Amount to remove from the order total"
            />

            <v-switch
              class="mt-2"
              v-model="amend_discount_active"
              color="blue darken-2"
              inset
            >
              <template v-slot:label>
                Discount Active
                <v-icon
                  right
                  :color="amend_discount_active ? 'success' : 'error'"
                >
                  {{
                    amend_discount_active ? "check_circle_outline" : "cancel"
                  }}
                </v-icon>
              </template>
            </v-switch>

            <v-dialog
              ref="dialog"
              v-model="amend_start_date_dialog"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  v-model="amend_start_date_text"
                  label="From Date"
                  prepend-icon="mdi-calendar"
                  readonly
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="amend_start_date"
                no-title
                v-on:change="amend_start_date_dialog = false"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="blue darken-2"
                  @click="amend_start_date_dialog = false"
                  >Cancel</v-btn
                >
              </v-date-picker>
            </v-dialog>

            <v-dialog
              ref="dialog"
              v-model="amend_end_date_dialog"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  v-model="amend_end_date_text"
                  label="From Date"
                  prepend-icon="mdi-calendar"
                  readonly
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="amend_end_date"
                no-title
                v-on:change="amend_end_date_dialog = false"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="blue darken-2"
                  @click="amend_end_date_dialog = false"
                  >Cancel</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-card-text>

          <v-card-actions class="dialogActions">
            <v-btn
              large
              type="submit"
              :loading="$store.getters.postcodesLoading"
              color="error"
              @click="deleteRow"
              outlined
            >
              Delete
            </v-btn>
            <v-spacer />
            <v-btn
              large
              type="submit"
              :loading="$store.getters.orderdiscountsLoading"
              color="blue darken-2"
              @click="amendRow"
              outlined
              :disabled="!valid"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "ViewOrderDiscounts",

  components: {},

  data: () => {
    return {
      dialog: false,
      valid: false,

      search: null,

      headers: [
        { text: "Code", value: "code" },
        { text: "Percentage", value: "discount_percentage" },
        { text: "Amount", value: "discount_amount" },
        { text: "Active", value: "discount_active" },
        { text: "Start Date", value: "start_date" },
        { text: "End Date", value: "end_date" },
      ],

      amend_type: 0,

      amend_id: null,
      amend_code: null,
      amend_discount_percentage: "",
      amend_discount_amount: "",
      amend_discount_active: true,
      amend_start_date: null,
      amend_end_date: null,

      amend_start_date_dialog: false,
      amend_end_date_dialog: false,

      required(fieldName) {
        return (v) => (v && v.length > 0) || `${fieldName} Required`;
      },

      rules_percentage: [
        (v) => /^\d*(\.\d{1,2})?$/.test(v) || "Invalid Amount Entered",
        (v) => (v < 100 && v != null) || `Maximum percentage 100`,
        (v) => Number.isInteger(Number(v)) || `Value must be an integer`,
      ],

      rules_amount: [
        (v) => /^\d*(\.\d{1,2})?$/.test(v) || "Invalid Amount Entered",
        (v) => v < 10000 || `Maximum value £9,999`,
      ],
    };
  },

  activated() {
    this.getAllDiscounts();
  },

  computed: {
    amend_start_date_text() {
      console.log("START DATE");
      console.log(this.amend_start_date);
      console.log(moment(this.amend_start_date));
      console.log(moment(this.amend_start_date, "YYYY-MM-DD"));
      return this.amend_start_date
        ? moment(this.amend_start_date, "YYYY-MM-DD").format(
            "dddd, MMMM Do YYYY"
          )
        : "";
    },

    amend_end_date_text() {
      return this.amend_end_date
        ? moment(this.amend_end_date).format("dddd, MMMM Do YYYY")
        : "";
    },
  },

  methods: {
    ...mapActions(["getAllDiscounts", "updateDiscount", "deleteDiscount"]),

    momentFormatDate(date) {
      return date ? moment(date).format("dddd, MMMM Do YYYY") : "";
    },

    clickedRow(item) {
      console.log("ROW ITEM");
      console.log(item);
      this.dialog = true;

      if (item.discount_amount > 0) {
        this.amend_type = 0;
      } else {
        this.amend_type = 1;
      }

      this.amend_id = item.id;
      this.amend_code = item.code;
      this.amend_discount_percentage = item.discount_percentage
        ? item.discount_percentage
        : "";
      this.amend_discount_amount = item.discount_amount
        ? item.discount_amount
        : "";
      this.amend_discount_active = Boolean(parseInt(item.discount_active));
      this.amend_start_date = item.start_date ? item.start_date : "";
      this.amend_end_date = item.end_date ? item.end_date : "";
    },

    async amendRow() {
      console.log("Amend Row");

      if (this.amend_type == 0) {
        //Amount type ensure percentage is 0
        this.amend_discount_percentage = 0;
      } else {
        //Percentage type ensure amount is 0
        this.amend_discount_amount = 0;
      }

      let data = {
        id: this.amend_id,
        code: this.amend_code,
        discount_percentage: this.amend_discount_percentage
          ? this.amend_discount_percentage
          : null,
        discount_amount: this.amend_discount_amount
          ? this.amend_discount_amount
          : null,
        discount_active: this.amend_discount_active ? 1 : 0,
        start_date: this.amend_start_date ? this.amend_start_date : null,
        end_date: this.amend_end_date ? this.amend_end_date : null,
      };

      await this.updateDiscount(data);
      this.dialog = false;
    },

    async deleteRow() {
      let result = await this.deleteDiscount(this.amend_id);
      if (result) {
        this.dialog = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>